import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { gaPageView } from "./lib/analytics";

import Landing from "./pages/Landing";
import { HowItWorks, Pricing, About, FAQ, Contact, Privacy, Terms, Disclaimer } from "./pages/Content";
import { Login, Register, ForgotPassword, ResetPassword } from "./pages/Auth";
import { AssessmentStart, AssessmentFlow } from "./pages/Assessment";
import FreeResults from "./pages/FreeResults";
import PaidReport, { PaymentSuccess, PaymentCancel } from "./pages/Report";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";

function RouteChangeTracker() {
  const location = useLocation();
  useEffect(() => {
    gaPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RouteChangeTracker />
          <Toaster position="top-center" richColors offset="80px" toastOptions={{ style: { zIndex: 100 } }} />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/how-it-works" element={<HowItWorks />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/disclaimer" element={<Disclaimer />} />

                  <Route path="/assessment/new" element={<AssessmentStart />} />
                  <Route path="/assessment/:id" element={<AssessmentFlow />} />
                  <Route path="/results/:id" element={<FreeResults />} />
                  <Route path="/report/:id" element={<PaidReport />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />

                  <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                  <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
